import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAFzdQbkJp9C9vJA-xMkKmIprcodnLyubQ",
  authDomain: "lmypet.firebaseapp.com",
  databaseURL: "https://lmypet.firebaseio.com",
  projectId: "lmypet",
  storageBucket: "lmypet.appspot.com",
  messagingSenderId: "553494742232",
  appId: "1:553494742232:web:b3d23f158fc7c5ef9343ad",
  measurementId: "G-WSVGYFL1EE",
});

const db = firebaseApp.firestore();
const auth = firebase.auth();
const authProvider = firebase.auth.EmailAuthProvider;
const storage = firebase.storage();

export { authProvider, db, auth, storage };
